import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface AverageDropRate {
  averageDropRate: number;
}

export interface GetAverageDropRateParams {
  sessionId?: string;
}

export const getAverageDropRateAPI = async (
  params: GetAverageDropRateParams,
) => {
  const response = await baseAPI.get<AverageDropRate>(
    `/dashboard/average-drop-rate/${params.sessionId}`,
  );
  return response.data;
};

export const getAverageDropRateQueryOptions = (
  params: GetAverageDropRateParams,
) =>
  queryOptions({
    queryKey: [KEYS.AVERAGE_DROP_RATE, params],
    queryFn: () => getAverageDropRateAPI(params),
    enabled: !!params.sessionId,
  });

export const useGetAverageDropRate = (params: GetAverageDropRateParams) => {
  return useQuery(getAverageDropRateQueryOptions(params));
};
